<div class="spinner">
  <div class="double-bounce1 flex items-center justify-center"><img class="w-13" src="assets/images/logo/logo-blanco.png" ></div>
  <div class="double-bounce2 flex items-center justify-center"><img class="w-13" src="assets/images/logo/logo-blanco.png" ></div>
</div>